import { Typography } from '@compass/components'

import { CellWrapper } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

export const replayedColumn = columnHelper.display({
  id: 'replayed',
  header: 'Replayed',
  cell: ({ row }) => {
    const replayed = row.original.replayed

    if (replayed == null) {
      return <Unavailable />
    }

    return (
      <CellWrapper>
        <Typography className={replayed ? 'text-red-800' : ''}>{replayed ? 'Yes' : 'No'}</Typography>
      </CellWrapper>
    )
  },
})
